var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=TV"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 16.8982V6.5H19.5V11.1838H19C18.4477 11.1838 18 11.6315 18 12.1838V16.8982H2.5ZM18 18.3982H14.4605L16.3748 19.9297C16.6336 20.1367 16.6755 20.5143 16.4685 20.773C16.2615 21.0318 15.8839 21.0737 15.6252 20.8667L13.1252 18.8667C12.9772 18.7483 12.9001 18.5741 12.9 18.3982H8.10002C8.09991 18.5741 8.02284 18.7483 7.87482 18.8667L5.37482 20.8667C5.11606 21.0737 4.73848 21.0318 4.53148 20.773C4.32447 20.5143 4.36643 20.1367 4.62518 19.9297L6.53953 18.3982H2C1.44772 18.3982 1 17.9505 1 17.3982V6C1 5.44771 1.44772 5 2 5H20C20.5523 5 21 5.44772 21 6V11.1838H22C22.5523 11.1838 23 11.6315 23 12.1838V18.4289C23 18.9811 22.5523 19.4289 22 19.4289H19C18.4477 19.4289 18 18.9811 18 18.4289V18.3982Z",
    fill: "#5B5B5B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/TV.13e2bf38ca5561169d7a012814a6ecc3.svg";
export { ForwardRef as ReactComponent };